const parseStr = (timeWork: string): string => {
  const listDate = timeWork.split('<br>');
  const dayWeek = new Date().getDay();
  if (listDate.length === 4) {
    switch (dayWeek) {
      case 0:
        return 'Сегодня c ' + listDate[2]?.slice(listDate[2]?.length - 11).replace('–', ' до ');
      case 6:
        return 'Сегодня c ' + listDate[1]?.slice(listDate[1]?.length - 11).replace('–', ' до ');
      default:
        return 'Сегодня c ' + listDate[0]?.slice(listDate[0]?.length - 11).replace('–', ' до ');
    }
  } else if (listDate.length === 5) {
    switch (dayWeek) {
      case 0:
        return 'Сегодня c ' + listDate[3]?.slice(listDate[3]?.length - 11).replace('–', ' до ');
      case 5:
        return 'Сегодня c ' + listDate[1]?.slice(listDate[1]?.length - 11).replace('–', ' до ');
      case 6:
        return 'Сегодня c ' + listDate[2]?.slice(listDate[2]?.length - 11).replace('–', ' до ');
      default:
        return 'Сегодня c ' + listDate[0]?.slice(listDate[0]?.length - 11).replace('–', ' до ');
    }
  } else {
    return timeWork;
  }
};

export const getTimeWork = (str: string): string => {
  if (typeof str === 'string') {
    switch (str) {
      case 'закрыт':
        return 'Закрыт';
      case 'круглосуточно':
        return 'Работает круглосуточно';
      default:
        return parseStr(str);
    }
  }
  return '';
};
